import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Box, Grid } from '@mui/material'
import SlideDetails from './SlideDetails'
import SelectionsMade from './SelectionsMade'
import ReportBuilder from './ReportBuilder'
import { getReportData, getSlideDiagnosis, getSummaryTreeData } from '../../../actions'
import { RootState } from '../../../reducers'

export default function Report({ trfBarcode, location, pseudoProcedureCode, handleViewerOpen }) {
  const dispatch = useDispatch()
  const reportOptions = useSelector((state: RootState) => state.setReportDiagnosisData)
  const slideDetailsData = useSelector((state: RootState) => state.addSummaryTreeData)
  const { procedureCodeId } = useSelector((state: RootState) => state.getCaseData)
  const [isLoading, setLoading] = useState(false)
  const [isDraftSave, setDraftSave] = useState(true)
  const [isListChanged, setListChanged] = useState(false)

  useEffect(() => {
    setLoading(true)
    if (location !== '') {
      dispatch(
        getSummaryTreeData({
          trfBarcode: trfBarcode,
          location: location,
          procedureCode: procedureCodeId,
        }),
      )
    }
  }, [location])

  useEffect(() => {
    if (slideDetailsData.payload && isLoading) {
      setTimeout(() => setLoading(false), 1500)
    }
  }, [isLoading, slideDetailsData])

  useEffect(() => {
    if (trfBarcode) {
      dispatch(getSlideDiagnosis({ trfBarcode: trfBarcode }))
      dispatch(getReportData({ trfBarcode: trfBarcode, procedureCode: procedureCodeId }))
    }
  }, [trfBarcode])

  return (
    <Box sx={{ width: '100%', ml: '40px', height: '85%' }}>
      <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }} style={{ height: '98%' }}>
        <Grid item xs={2.8}>
          {location && (
            <SlideDetails
              isLoading={isLoading}
              location={location}
              trfBarcode={trfBarcode}
              handleViewerOpen={handleViewerOpen}
            />
          )}
        </Grid>
        <Grid item xs={4}>
          {isListChanged !== undefined && (
            <ReportBuilder location={location} pseudoProcedureCode={pseudoProcedureCode} />
          )}
        </Grid>
        <Grid item xs={5}>
          {reportOptions && (
            <SelectionsMade trfBarcode={trfBarcode} location={location} pseudoProcedureCode={pseudoProcedureCode} />
          )}
        </Grid>
      </Grid>
    </Box>
  )
}
